import { createFileRoute } from '@tanstack/react-router'

import { SessionChannelPage } from '#features/sessions/session-channel-page.tsx'
import { SessionPageSkeleton } from '#features/sessions/session-page-skeleton.tsx'

export const Route = createFileRoute(
  '/_app/$workspace/_dashboard/sessions/$id',
)({
  head: () => ({ meta: [{ title: 'Session' }] }),
  component: RouteComponent,
  // The same skeleton the page itself shows while its query resolves, so route
  // navigation and data loading render one continuous placeholder instead of a
  // spinner that swaps into a skeleton.
  pendingComponent: SessionPageSkeleton,
})

function RouteComponent() {
  const params = Route.useParams()
  return <SessionChannelPage key={params.id} sessionId={params.id} />
}
